export enum ActionTypes {
    CLEAR_STORE = "CLEAR_STORE",
}
